import { useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";

export function usePasswordLocation() {
  const { workspaceId, entryId } = useParams<{ workspaceId?: string; entryId?: string }>();
  const navigate = useNavigate();
  const openWorkspace = useCallback((nextWorkspaceId: string | null) => navigate(nextWorkspaceId ? `/passwords/${nextWorkspaceId}` : "/passwords"), [navigate]);
  const openEntry = useCallback((nextEntryId: string | null) => {
    if (!workspaceId) return;
    navigate(nextEntryId ? `/passwords/${workspaceId}/${nextEntryId}` : `/passwords/${workspaceId}`);
  }, [navigate, workspaceId]);
  return { workspaceId: workspaceId ?? null, entryId: entryId ?? null, openWorkspace, openEntry };
}
